// import React  from 'react';
export default class PrintCheckItem 
{
    constructor(item) 
    {
        this.ExportId = item.exportId;
        this.FirstCheck=item.firstCheck;
        // this.Notes=(
        //     <span>
        //         Please select the offices for this end of month payment export, then click on the start button. 
        //         <br/><br/>
        //         The payment export will start within an hour. 
        //     </span>);

    }

    
}
